import {
  FETCH_VA_RATES_REQUEST,
  FETCH_VA_RATES_SUCCESS,
  FETCH_VA_RATES_FAILURE,
  FETCH_VA_EXCHANGERS_LIST_REQUEST,
  FETCH_VA_EXCHANGERS_LIST_SUCCESS,
  FETCH_VA_EXCHANGERS_LIST_FAILURE,
} from 'actionTypes';

import createReducer from './createReducer';

export const initialState = {
  list: {
    items: [],
    isFetching: false,
    isInitialized: false,
    isRequestFailed: false,
  },
  rates: {},
};

const exchangers = createReducer(initialState, {
  [FETCH_VA_RATES_REQUEST]: (state, { payload: { cityKey, dateKey } }) => ({
    ...state,
    rates: {
      ...state.rates,
      [cityKey]: {
        ...(state.rates[cityKey] || {}),
        [dateKey]: {
          ...(state.rates[cityKey]?.[dateKey] || {}),
          isFetching: true,
          isInitialized: false,
        },
      },
    },
  }),
  [FETCH_VA_RATES_SUCCESS]: (
    state,
    { payload: { cityKey, dateKey, entities } }
  ) => ({
    ...state,
    rates: {
      ...state.rates,
      [cityKey]: {
        ...(state.rates[cityKey] || {}),
        [dateKey]: {
          ...(state.rates[cityKey]?.[dateKey] || {}),
          entities,
          isFetching: false,
          isInitialized: true,
        },
      },
    },
  }),
  [FETCH_VA_RATES_FAILURE]: (state, { payload: { cityKey, dateKey } }) => ({
    ...state,
    rates: {
      ...state.rates,
      [cityKey]: {
        ...(state.rates[cityKey] || {}),
        [dateKey]: {
          ...(state.rates[cityKey]?.[dateKey] || {}),
          isFetching: false,
          isInitialized: true,
        },
      },
    },
  }),
  [FETCH_VA_EXCHANGERS_LIST_REQUEST]: state => ({
    ...state,
    list: {
      ...state.list,
      isFetching: true,
      isInitialized: false,
      isRequestFailed: false,
    },
  }),
  [FETCH_VA_EXCHANGERS_LIST_SUCCESS]: (state, { payload }) => ({
    ...state,
    list: {
      ...state.list,
      items: payload || [],
      isFetching: false,
      isInitialized: true,
      isRequestFailed: false,
    },
  }),
  [FETCH_VA_EXCHANGERS_LIST_FAILURE]: state => ({
    ...state,
    list: {
      ...state.list,
      isFetching: false,
      isInitialized: true,
      isRequestFailed: true,
    },
  }),
});

export default exchangers;
